/**
 * @generated SignedSource<<86a10b6ee83857433f06eb4ff3aa2cbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type recoilGetFileEntitiesQuery$variables = {
  file_reference_source: string;
  file_source: string;
};
export type recoilGetFileEntitiesQuery$data = {
  readonly _sys_ingestion_get_entities: ReadonlyArray<{
    readonly count: number;
    readonly entity: string;
  } | null> | null;
};
export type recoilGetFileEntitiesQuery = {
  response: recoilGetFileEntitiesQuery$data;
  variables: recoilGetFileEntitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "file_reference_source"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "file_source"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "file_reference_source",
            "variableName": "file_reference_source"
          },
          {
            "kind": "Variable",
            "name": "file_source",
            "variableName": "file_source"
          }
        ],
        "kind": "ObjectValue",
        "name": "params"
      }
    ],
    "concreteType": "get_entities_output",
    "kind": "LinkedField",
    "name": "_sys_ingestion_get_entities",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilGetFileEntitiesQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recoilGetFileEntitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "312f5921902bf08a41356518846aa53a",
    "id": null,
    "metadata": {},
    "name": "recoilGetFileEntitiesQuery",
    "operationKind": "query",
    "text": "query recoilGetFileEntitiesQuery(\n  $file_reference_source: String!\n  $file_source: String!\n) {\n  _sys_ingestion_get_entities(params: {file_reference_source: $file_reference_source, file_source: $file_source}) {\n    entity\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "6efe64236e82d8a052c0338f1df98635";

export default node;
